import React, { Component } from 'react';
import './CreatorPlatform.css';
import lottie from 'lottie-web';
import * as encryptUtils from './encryptDecryptUtils';
import * as loggingUtils from "./utils/loggingUtils";
import PlatformSidebar from './PlatformSidebar';
import Onboarding from './Onboarding.js';
import AddFunds from './AddFunds.js';
import CreateLiveStreamButton from "./CreateLiveStreamButton";
import ImportFromPassword from './ImportFromPassword';
import SubscribeModal from "./SubscribeModal.js";
import ProfileBackground from "./ProfileBackground.js";
import LiveMintDetails from "./LiveMintDetails";
import LivestreamPage from "./LivestreamPage";
import ProfileInformationContainer from "./ProfileInformationContainer";
import TransactionStatus from "./TransactionStatus";
import StreamerProfileSocials from "./StreamerProfileSocials";
import { createAlchemyWeb3 } from "@alch/alchemy-web3";
import AddToCalendar from './react-add-to-calendar/ReactAddToCalendar';
import 'react-add-to-calendar/dist/react-add-to-calendar.css';
import {
  contractAddress,
  mainnetContractAddress,
  bondingCurveContractAddress,
  bondingCurveOrchestratorContractAddress,
  mainnetBondingCurveContractAddress,
  mainnetBondingCurveOrchestratorContractAddress
} from "./config";

const contract = require("./artifacts/contracts/The402NFT.sol/The402NFT.json");
const contract2 = require("./artifacts/contracts/BondingCurveNFT.sol/BondingCurveNFT.json");
const contract3 = require("./artifacts/contracts/BondingCurveOrchestrator.sol/BondingCurveOrchestrator.json");
const animation = require("./animation.json");

let web3;
let usedContractAddress;
let usedContractAddressBondingCurve;
let usedContractAddressBondingCurveV2;
if(process.env.REACT_APP_IS_MAINNET !== "testnet") {
  web3 = createAlchemyWeb3(process.env.REACT_APP_ETHEREUM_WEBSOCKET_URL);
  usedContractAddress = mainnetContractAddress;
  usedContractAddressBondingCurve = mainnetBondingCurveContractAddress;
  usedContractAddressBondingCurveV2 = mainnetBondingCurveOrchestratorContractAddress;
} else {
  web3 = createAlchemyWeb3(process.env.REACT_APP_GOERLI_WEBSOCKET_URL);
  usedContractAddress = contractAddress;
  usedContractAddressBondingCurve = bondingCurveContractAddress;
  usedContractAddressBondingCurveV2 = bondingCurveOrchestratorContractAddress;
}

const DURATION = 5000;

class StreamerProfile extends Component {
  constructor(props) {
    super(props);
    this.addAddress = this.addAddress.bind(this);
    this.getShouldShowLivestream = this.getShouldShowLivestream.bind(this);
    this.getStream = this.getStream.bind(this);
    this.getTimeLeft = this.getTimeLeft.bind(this);
    this.selectModal = this.selectModal.bind(this);
    this.markAsSubscribed = this.markAsSubscribed.bind(this);
    this.onUserClickedConnectWallet =
      this.onUserClickedConnectWallet.bind(this);
    this.removeAddress = this.removeAddress.bind(this);
    this.selectSubscribeModal = this.selectSubscribeModal.bind(this);
    this.setAddresses = this.setAddresses.bind(this);
    this.setENS = this.setENS.bind(this);
    this.setTransactionStatus = this.setTransactionStatus.bind(this);
    this.addMessage = this.addMessage.bind(this);
    this.updateCurrentMessage = this.updateCurrentMessage.bind(this);
    this.setAnimatedImageForUser = this.setAnimatedImageForUser.bind(this);
    this.payStreamer = this.payStreamer.bind(this);
    this.mintFromChat = this.mintFromChat.bind(this);
    this.updateUserInfo = this.updateUserInfo.bind(this);
    this.logMinuteAttended = this.logMinuteAttended.bind(this);
    this.triggerAnimation = this.triggerAnimation.bind(this);
    this.setMessageInfo = this.setMessageInfo.bind(this);
    this.addPaginatedMessages = this.addPaginatedMessages.bind(this);
    this.addSubscribedMessage = this.addSubscribedMessage.bind(this);
    this.doesHaveCalendarEventTimes = this.doesHaveCalendarEventTimes.bind(this);
    this.getCalendarStartTime = this.getCalendarStartTime.bind(this);
    this.getCalendarEndTime = this.getCalendarEndTime.bind(this);

    this.state = {
      addresses: [],
      modalShown: '',
      createdItems: [],
      creatorAddress: "",
      creatorBackgroundBlurredImage: "",
      creatorImage: "https://pbs.twimg.com/profile_images/1521659343309086720/2Lle15fa_400x400.png",
      creatorName: "",
      currentMessage: '',
      emotes: [],
      ens: "",
      liveCalendarStartTimesByAuthUUID: {},
      liveCalendarEndTimesByAuthUUID: {},
      liveNFTItem: null,
      liveNFTDaysLeft: "--",
      liveNFTHoursLeft: "--",
      liveNFTMinutesLeft: "--",
      liveNFTSecondsLeft: "--",
      liveNFTName: "",
      liveNFTBuyPrice: 0,
      liveNFTBuyCreatorFee: 0,
      liveNFTBuyPriceTotal: 0,
      liveNFTSellPrice: 0,
      liveNFTSellCreatorFee: 0,
      liveNFTSellPriceTotal: 0,
      livestreamGatingLogicItems: [],
      livestreamURLs: [],
      livestreamURLPreviews: [],
      liveTimesByAuthUUID: {},
      messages: [],
      nextToken: null,
      nftSalesLivestream: null,
      shouldShowLiveStream: false,
      shouldShowLiveStreamForPastVods: [],
      shouldStreamInTestMode: true,
      socials: {},
      subscriberStatuses: {},
      transactionStatus: "None",
      userInfo: null,
      badgeInfo: null,
      userOwnedNFTs: [],
      secondsWatched: 0
    }
  }

  doesHaveCalendarEventTimes() {
    let hasStartTime =
      this.state.liveCalendarStartTimesByAuthUUID != null &&
      ("global" in this.state.liveCalendarStartTimesByAuthUUID ||
        (this.state.liveNFTItem != null && this.state.liveNFTItem.authUUID in this.state.liveCalendarStartTimesByAuthUUID));
    let hasEndTime =
      this.state.liveCalendarEndTimesByAuthUUID != null &&
      ("global" in this.state.liveCalendarEndTimesByAuthUUID ||
        (this.state.liveNFTItem != null && this.state.liveNFTItem.authUUID in this.state.liveCalendarEndTimesByAuthUUID));
    return hasStartTime && hasEndTime;
  }

  getCalendarStartTime() {
    if("global" in this.state.liveCalendarStartTimesByAuthUUID) {
      return this.state.liveCalendarStartTimesByAuthUUID["global"];
    } else {
      return this.state.liveCalendarStartTimesByAuthUUID[this.state.liveNFTItem.authUUID];
    }
  }

  getCalendarEndTime() {
    if("global" in this.state.liveCalendarEndTimesByAuthUUID) {
      return this.state.liveCalendarEndTimesByAuthUUID["global"];
    } else {
      return this.state.liveCalendarEndTimesByAuthUUID[this.state.liveNFTItem.authUUID];
    }
  }

  addSubscribedMessage(value) {
    if(value != null && value.data != null && value.data.messageSent != null) {
      let messages = this.state.messages;
      let newMessage = value.data.messageSent;
      messages.push(newMessage);
      this.setState({
        messages,
      });
    }
  }

  addPaginatedMessages(messageInfo) {
    if(messageInfo != null && messageInfo.data != null && messageInfo.data.getMessages != null) {
      let messages = messageInfo.data.getMessages["messages"].reverse();
      let recentMessages = this.state.messages;
      messages = messages.concat(recentMessages);
      let nextToken = messageInfo.data.getMessages["nextToken"];
      this.setState({
        messages,
        nextToken
      });
    }
  }

  setMessageInfo(messageInfo) {
    if(messageInfo != null && messageInfo.data != null && messageInfo.data.getMessages != null) {
      let messages = messageInfo.data.getMessages["messages"].reverse();
      let nextToken = messageInfo.data.getMessages["nextToken"];
      this.setState({
        messages,
        nextToken
      });
    }
  }

  async logMinuteAttended(player) {
    if(player.current != null) {
      let secondsWatched = 0;
      for(let i = 0; i < player.current.played.length; i++) {
        secondsWatched += player.current.played.end(i) - player.current.played.start(i)
      }
      if(Math.floor(secondsWatched/60) !== Math.floor(this.state.secondsWatched/60)) {
        this.setState({
          secondsWatched,
        });
        let userId = this.props.account != null
          ? this.props.account.address.toLowerCase()
          : encryptUtils.getWalletUnconnectedUserId();
        let badgeInfo = await encryptUtils.logMinuteAttended(this.state.creatorAddress, userId);
        this.setState({
          badgeInfo,
        });
      } else {
        this.setState({
          secondsWatched,
        });
      }
    }
  }

  triggerAnimation() {
    let elements = document.getElementsByClassName("videoItem-LiveStream");
    if(elements.length > 0) {
      let container = elements[0].parentElement;
      let animObj = lottie.loadAnimation({
        container: container,
        renderer: 'svg',
        loop: false,
        autoplay: true,
        animationData: animation,
        rendererSettings: {
          className: "the402-lottie-animation",
          preserveAspectRatio: 'none',
        }
      });
      animObj.setSpeed(0.4);

      animObj.addEventListener('complete', () => {
        let animations = document.getElementsByClassName("the402-lottie-animation");
        if(animations.length !== 0) {
          for(let index in animations) {
            if(typeof animations[index] === "object") {
              // Is DOM element
              animations[index].remove();
            }
          }
        }
      });
    }
  }

  updateUserInfo(userInfo) {
    this.setState({
      userInfo,
    });
  }

  setTransactionStatus(status) {
    this.setState({
      transactionStatus: status,
    });
  }

  markAsSubscribed(creator, subscriber) {
    creator = creator.toLowerCase();
    subscriber = subscriber.toLowerCase();
    let creatorMapping;
    let subscriberStatusesCopy = {...this.state.subscriberStatuses};
    if(!(creator in subscriberStatusesCopy)) {
      creatorMapping = {};
      creatorMapping[subscriber] = true;
    } else {
      creatorMapping = subscriberStatusesCopy[creator];
      creatorMapping[subscriber] = true;
    }
    subscriberStatusesCopy[creator] = creatorMapping;
    this.setState({
      subscriberStatuses: subscriberStatusesCopy,
    });
  }

  async mintFromChat() {
    loggingUtils.logEvent(
      this.props.account != null
        ? this.props.account.address
        : encryptUtils.getWalletUnconnectedUserId(),
      "streamer_profile",
      "streamer_profile_enter_mint_from_chat",
      "info",
      "https://the402.xyz",
      {}
    );
    if(this.state.nftSalesLivestream == null) {
      return false;
    }
    if(this.props.account == null) {
      this.onUserClickedConnectWallet();
      return false;
    }
    this.setTransactionStatus("Pending");
    if(this.state.nftSalesLivestream.type === "manifold721") {
      let didApprove = await encryptUtils.buyManifold721Emote(
        this.props.account.address,
        this.state.nftSalesLivestream.contractAddress,
        this.state.nftSalesLivestream.claimIndex,
        this.state.nftSalesLivestream.price
      );
      if(didApprove) {
        loggingUtils.logEvent(
          this.props.account.address,
          "external_purchases",
          "external_purchase",
          "info",
          "https://the402.xyz",
          {
            "type": this.state.nftSalesLivestream.type,
            "price": this.state.nftSalesLivestream.price,
            "contractAddress": this.state.nftSalesLivestream.contractAddress
          }
        );
        this.setTransactionStatus("Purchase Complete");
        return true;
      } else {
        this.setTransactionStatus("None");
        return false;
      }
    } else if(this.state.nftSalesLivestream.type === "manifold1155") {
      let didApprove = await encryptUtils.buyManifold721Emote(
        this.props.account.address,
        this.state.nftSalesLivestream.contractAddress,
        this.state.nftSalesLivestream.price,
        this.state.nftSalesLivestream.tokenId
      );
      if(didApprove) {
        loggingUtils.logEvent(
          this.props.account.address,
          "external_purchases",
          "external_purchase",
          "info",
          "https://the402.xyz",
          {
            "type": this.state.nftSalesLivestream.type,
            "price": this.state.nftSalesLivestream.price,
            "contractAddress": this.state.nftSalesLivestream.contractAddress
          }
        );
        this.setTransactionStatus("Purchase Complete");
        return true;
      } else {
        this.setTransactionStatus("None");
        return false;
      }
    } else if(this.state.nftSalesLivestream.type === "zora721") {
      let didApprove = await encryptUtils.buyZora721Emote(
        this.props.account.address,
        this.state.nftSalesLivestream.contractAddress,
        this.state.nftSalesLivestream.price
      );
      if(didApprove) {
        loggingUtils.logEvent(
          this.props.account.address,
          "external_purchases",
          "external_purchase",
          "info",
          "https://the402.xyz",
          {
            "type": this.state.nftSalesLivestream.type,
            "price": this.state.nftSalesLivestream.price,
            "contractAddress": this.state.nftSalesLivestream.contractAddress
          }
        );
        this.setTransactionStatus("Purchase Complete");
        return true;
      } else {
        this.setTransactionStatus("None");
        return false;
      }
    } else if(this.state.nftSalesLivestream.type === "poap") {
      let didApprove = await encryptUtils.claimPOAP(this.props.account.address);
      if(didApprove) {
        loggingUtils.logEvent(
          this.props.account.address,
          "poap",
          "poap_claim",
          "info",
          "https://the402.xyz",
          {
            "type": this.state.nftSalesLivestream.type
          }
        );
        this.setTransactionStatus("Claim Complete");
        return true;
      } else {
        this.setTransactionStatus("None");
        return false;
      }
    }
  }

  async payStreamer(amount) {
    if(this.props.account != null) {
      loggingUtils.logEvent(
        this.props.account.address,
        "streamer_profile",
        "streamer_profile_enter_pay_streamer_flow",
        "info",
        "https://the402.xyz",
        {}
      );
      this.setState({
        transactionStatus: "Pending",
      });
      let didApprove = await encryptUtils.payStreamer(
        this.props.account.address,
        this.state.creatorAddress,
        amount
      );
      if (!didApprove) {
        this.setState({
          transactionStatus: "None",
        });
        return false;
      } else {
        loggingUtils.logEvent(
          this.props.account.address,
          "external_payments",
          "external_payment",
          "info",
          "https://the402.xyz",
          {}
        );
        let newBadgeInfo = await encryptUtils.logMicropayment(
          this.state.item.creatorAddress,
          this.props.account.address,
          amount
        );
        this.setState({
          badgeInfo: newBadgeInfo,
          transactionStatus: "Payment Complete"
        });
        return true;
      }
    } else {
      this.onUserClickedConnectWallet();
      return false;
    }
  }

  onUserClickedConnectWallet() {
    loggingUtils.logEvent(
      encryptUtils.getWalletUnconnectedUserId(),
      "streamer_profile",
      "streamer_profile_subscribe_with_wallet_disconnected",
      "info",
      "https://the402.xyz",
      {}
    );
    let buttons = document.getElementsByTagName("button");
    for (let i = 0; i < buttons.length; i++) {
      let button = buttons[i];
      if (button.outerText === "Connect Wallet") {
        button.click();
      }
    }
  }

  selectSubscribeModal() {
    if(this.props.account != null) {
      loggingUtils.logEvent(
        this.props.account != null
          ? this.props.account.address
          : encryptUtils.getWalletUnconnectedUserId(),
        "streamer_profile",
        "streamer_profile_select_subscribe_modal",
        "info",
        "https://the402.xyz",
        {}
      );
      this.selectModal("subscribe");
    } else {
      this.onUserClickedConnectWallet();
    }
  }

  setENS(ens) {
    this.setState({
      ens,
    });
  }

  setAddresses(addresses) {
    this.setState({
      addresses,
    });
  }

  addAddress(joiner) {
    let users = [...this.state.addresses];
    users.push(joiner);
    this.setState({
      addresses: users,
    });
  }

  removeAddress(leaver) {
    let users = [...this.state.addresses];
    let index = users.indexOf(leaver);
    if (index !== -1) {
      users.splice(index, 1);
    }
    this.setState({
      addresses: users,
    });
  }

  addMessage(message) {
    let messagesCopy = [...this.state.messages];
    messagesCopy.push(message);
    this.setState({
      messages: messagesCopy,
    });
  }

  updateCurrentMessage(newMessage) {
    this.setState({
      currentMessage: newMessage,
    });
  }

  setAnimatedImageForUser(sender, image) {
    let animatedImagesCopy = {...this.state.animatedImageForUser};
    animatedImagesCopy[sender] = image;
    this.setState({
      animatedImageForUser: animatedImagesCopy
    });
    setTimeout(() => {
      animatedImagesCopy = {...this.state.animatedImageForUser};
      delete animatedImagesCopy[sender];
      this.setState({
        animatedImageForUser: animatedImagesCopy,
      });
    }, DURATION);
  }

  async getShouldShowLivestream() {
    let item = this.state.liveNFTItem;
    if(item == null && this.state.createdItems.length > 0) {
      item = this.state.createdItems[this.state.createdItems.length - 1];
    }

    let shouldShowLiveStream = await encryptUtils.getShouldShowLivestreamForVOD(
      this.props.account != null ? this.props.account.address : "",
      item,
      this.state.creatorAddress
    );
    this.setState({
      shouldShowLiveStream,
    });
  }

  getTimeLeft() {
    let timeLeft;
    if(this.state.liveNFTItem == null) {
      return;
    }
    if(this.state.liveNFTItem.liquidityPeriodLength === "0") {
      return;
    } else if(this.state.liveNFTItem.liquidityPeriodStart === "-1") {
      let secondsLeft = parseInt(this.state.liveNFTItem.liquidityPeriodLength);
      let days = Math.floor(secondsLeft / 86400);
      secondsLeft -= days * 86400;
      let hours = Math.floor(secondsLeft / 3600);
      secondsLeft -= hours * 3600;
      let minutes = Math.floor(secondsLeft / 60);
      secondsLeft -= minutes * 60;
      let seconds = Math.floor(secondsLeft);
      this.setState({
        liveNFTDaysLeft: days,
        liveNFTHoursLeft: hours,
        liveNFTMinutesLeft: minutes,
        liveNFTSecondsLeft: seconds
      });
    } else {
      let end = parseInt(this.state.liveNFTItem.liquidityPeriodLength) + parseInt(this.state.liveNFTItem.liquidityPeriodStart);
      let secondsLeft = end - Date.now()/1000;
      if(secondsLeft < 0) {
        return;
      } else {
        let days = Math.floor(secondsLeft / 86400);
        secondsLeft -= days * 86400;
        let hours = Math.floor(secondsLeft / 3600);
        secondsLeft -= hours * 3600;
        let minutes = Math.floor(secondsLeft / 60);
        secondsLeft -= minutes * 60;
        let seconds = Math.floor(secondsLeft);
        this.setState({
          liveNFTDaysLeft: days,
          liveNFTHoursLeft: hours,
          liveNFTMinutesLeft: minutes,
          liveNFTSecondsLeft: seconds
        });
      }
    }
    this.setState({
      timeLeft,
    });
  }

  async componentDidMount() {
    let urlSplit = window.location.href.split("/");
    let name = urlSplit[urlSplit.length - 1];
    let [data, subscriberStatuses] = await Promise.all([
      encryptUtils.getStreamerProfileInfo(name),
      encryptUtils.getSubscriberStatuses()
    ]);
    this.setState({
      createdItems: data.createdItems,
      creatorAddress: data.creatorAddress,
      creatorBackgroundBlurredImage: data.creatorBackgroundBlurredImage,
      creatorImage: data.creatorImage,
      creatorName: data.creatorName,
      emotes: data.emotes,
      liveCalendarStartTimesByAuthUUID: data.liveCalendarStartTimesByAuthUUID,
      liveCalendarEndTimesByAuthUUID: data.liveCalendarEndTimesByAuthUUID,
      liveNFTItem: data.liveNFTInfo,
      liveNFTName: data.liveNFTInfo != null ? data.liveNFTInfo.name : "",
      liveNFTBuyPrice: data.liveNFTInfo != null ? data.liveNFTInfo.baseBuyPrice : 0,
      liveNFTBuyCreatorFee: data.liveNFTInfo != null ? data.liveNFTInfo.currentBuyFeePerThousand / 10 : 0,
      liveNFTBuyPriceTotal: data.liveNFTInfo != null ? data.liveNFTInfo.mintPrice : 0,
      liveNFTSellPrice: data.liveNFTInfo != null ? data.liveNFTInfo.baseSellPrice : 0,
      liveNFTSellCreatorFee: data.liveNFTInfo != null ? data.liveNFTInfo.currentSellFeePerThousand / 10 : 0,
      liveNFTSellPriceTotal: data.liveNFTInfo != null ? data.liveNFTInfo.sellPrice : 0,
      livestreamGatingLogicItems: data.livestreamGatingLogicItems,
      livestreamURLs: data.livestreamURLs,
      livestreamURLPreviews: data.livestreamURLPreviews,
      liveTimesByAuthUUID: data.liveTimesByAuthUUID,
      nftSalesLivestream: data.nftSalesLivestream,
      shouldStreamInTestMode: data.shouldStreamInTestMode,
      socials: data.socials,
      subscriberStatuses
    });
    let userId = this.props.account != null
        ? this.props.account.address.toLowerCase()
        : encryptUtils.getWalletUnconnectedUserId();
    let [
      shouldShowLiveStreamForPastVods,
      userInfo,
      badgeInfo,
      userOwnedNFTs,
      dummyStreamInfo,
      dummyShouldShowLivestreamInfo
    ] = await Promise.all([
      encryptUtils.getShouldShowLiveStreamForVODs(
        this.props.account != null ? this.props.account.address : "",
        data.livestreamGatingLogicItems,
        data.creatorAddress
      ),
      encryptUtils.getUserProfileInfo(userId),
      encryptUtils.getBadgeInfo(data.creatorAddress, userId),
      encryptUtils.getUserOwnedNFTImages(userId),
      this.getStream(),
      this.getShouldShowLivestream()
    ]);
    this.setState({
      shouldShowLiveStreamForPastVods,
      userInfo,
      badgeInfo,
      userOwnedNFTs
    });

    if(data.liveNFTInfo != null) {
      setInterval(this.getTimeLeft, 1000);
    }

    let self = this;
    let item = data.liveNFTInfo;
    const ppvContract = new web3.eth.Contract(contract.abi, usedContractAddress);
    const bondingCurveContract = new web3.eth.Contract(contract2.abi, usedContractAddressBondingCurve);
    const bondingCurveV2Contract = new web3.eth.Contract(
      contract3.abi,
      usedContractAddressBondingCurveV2
    );
    ppvContract.events
      .ItemMinted()
      .on("data", function (event) {
        let data = event.returnValues;
        console.log(data);
        if (data["authUUID"] !== item["authUUID"]) {
          return;
        }
        item["mintCount"] =
          parseInt(item["mintCount"]) + parseInt(data["count"]);
        self.setState({
          liveNFTItem: item,
        });
        if (
          self.props.account == null ||
          data["to"].toLowerCase() !== self.props.account.address.toLowerCase()
        ) {
          return;
        }
        self.setState({
          transactionStatus: "Mint Complete",
        });
      })
      .on("error", function (event) {
        self.setState({
          transactionStatus: "Failed",
        });
      });
    bondingCurveContract.events
      .ItemMinted()
      .on("data", async function (event) {
        let data = event.returnValues;
        console.log(data);
        if (data["authUUID"] !== item["authUUID"]) {
          return;
        }
        let pastBondingCurveMintEvents = await bondingCurveContract.getPastEvents("ItemMinted", {
          fromBlock: 0,
          toBlock: 'latest'
        });
        let pastBondingCurveBurnEvents = await bondingCurveContract.getPastEvents("ItemBurned", {
          fromBlock: 0,
          toBlock: 'latest'
        });
        let filteredPastBondingCurveMintEvents = pastBondingCurveMintEvents.filter(event => event.returnValues.authUUID === item.authUUID);
        let filteredPastBondingCurveBurnEvents = pastBondingCurveBurnEvents.filter(event => event.returnValues.authUUID === item.authUUID);
        let newSupply = filteredPastBondingCurveMintEvents.length - filteredPastBondingCurveBurnEvents.length;
        let tokenId = item["tokenId"];
        let currentBuyPrice = await encryptUtils.computeCurrentPrice(tokenId, newSupply + 1, "liquid");
        let currentSellPrice = await encryptUtils.computeCurrentPrice(tokenId, newSupply, "liquid");
        let moneyInContract = await encryptUtils.computeMoneyInContract(tokenId, "liquid");
        let currentBuyFeePerThousand = item["currentBuyFeePerThousand"];
        let currentSellFeePerThousand = item["currentSellFeePerThousand"];
        item["baseBuyPrice"] = currentBuyPrice;
        item["baseSellPrice"] = currentSellPrice;
        currentBuyPrice *= (1 + currentBuyFeePerThousand/1000);
        currentSellPrice *= (1 - (currentSellFeePerThousand + 25)/1000);
        item["mintPrice"] = currentBuyPrice;
        item["sellPrice"] = currentSellPrice;
        item["moneyInContract"] = moneyInContract;
        item["currentSupply"] = newSupply;
        self.setState({
          liveNFTItem: item,
        });
        if (
          self.props.account == null ||
          data["to"].toLowerCase() !== self.props.account.address.toLowerCase()
        ) {
          return;
        }
        self.setState({
          transactionStatus: "Mint Complete",
        });
      })
      .on("error", function (event) {
        self.setState({
          transactionStatus: "Failed",
        });
      });
    bondingCurveContract.events
      .ItemBurned()
      .on("data", async function (event) {
        let data = event.returnValues;
        console.log(data);
        if (data["authUUID"] !== item["authUUID"]) {
          return;
        }
        let pastBondingCurveMintEvents = await bondingCurveContract.getPastEvents("ItemMinted", {
          fromBlock: 0,
          toBlock: 'latest'
        });
        let pastBondingCurveBurnEvents = await bondingCurveContract.getPastEvents("ItemBurned", {
          fromBlock: 0,
          toBlock: 'latest'
        });
        let filteredPastBondingCurveMintEvents = pastBondingCurveMintEvents.filter(event => event.returnValues.authUUID === item.authUUID);
        let filteredPastBondingCurveBurnEvents = pastBondingCurveBurnEvents.filter(event => event.returnValues.authUUID === item.authUUID);
        let newSupply = filteredPastBondingCurveMintEvents.length - filteredPastBondingCurveBurnEvents.length;
        let tokenId = item["tokenId"];
        let currentBuyPrice = await encryptUtils.computeCurrentPrice(tokenId, newSupply + 1, "liquid");
        let currentSellPrice = await encryptUtils.computeCurrentPrice(tokenId, newSupply, "liquid");
        let moneyInContract = await encryptUtils.computeMoneyInContract(tokenId, "liquid");
        let currentBuyFeePerThousand = item["currentBuyFeePerThousand"];
        let currentSellFeePerThousand = item["currentSellFeePerThousand"];
        item["baseBuyPrice"] = currentBuyPrice;
        item["baseSellPrice"] = currentSellPrice;
        currentBuyPrice *= (1 + currentBuyFeePerThousand/1000);
        currentSellPrice *= (1 - (currentSellFeePerThousand + 25)/1000);
        item["mintPrice"] = currentBuyPrice;
        item["sellPrice"] = currentSellPrice;
        item["moneyInContract"] = moneyInContract;
        item["currentSupply"] = newSupply;
        self.setState({
          liveNFTItem: item,
        });
        if (
          self.props.account == null ||
          data["burner"].toLowerCase() !== self.props.account.address.toLowerCase()
        ) {
          return;
        }
        self.setState({
          transactionStatus: "Burn Complete",
        });
      })
      .on("error", function (event) {
        self.setState({
          transactionStatus: "Failed",
        });
      });
    bondingCurveV2Contract.events
      .ItemMinted()
      .on("data", async function (event) {
        let data = event.returnValues;
        console.log(data);
        if (data["authUUID"] !== item["authUUID"]) {
          return;
        }
        let pastBondingCurveMintEvents = await bondingCurveV2Contract.getPastEvents("ItemMinted", {
          fromBlock: 0,
          toBlock: 'latest'
        });
        let pastBondingCurveBurnEvents = await bondingCurveV2Contract.getPastEvents("ItemBurned", {
          fromBlock: 0,
          toBlock: 'latest'
        });
        let filteredPastBondingCurveMintEvents = pastBondingCurveMintEvents.filter(event => event.returnValues.authUUID === item.authUUID);
        let filteredPastBondingCurveBurnEvents = pastBondingCurveBurnEvents.filter(event => event.returnValues.authUUID === item.authUUID);
        let newSupply = filteredPastBondingCurveMintEvents.length - filteredPastBondingCurveBurnEvents.length;
        let tokenId = item["tokenId"];
        let currentBuyPrice = await encryptUtils.computeCurrentPrice(tokenId, newSupply + 1, "liquidv2");
        let currentSellPrice = await encryptUtils.computeCurrentPrice(tokenId, newSupply, "liquidv2");
        let moneyInContract = await encryptUtils.computeMoneyInContract(tokenId, "liquidv2");
        let currentBuyFeePerThousand = item["currentBuyFeePerThousand"];
        let currentSellFeePerThousand = item["currentSellFeePerThousand"];
        item["baseBuyPrice"] = currentBuyPrice;
        item["baseSellPrice"] = currentSellPrice;
        currentBuyPrice *= (1 + currentBuyFeePerThousand/1000);
        currentSellPrice *= (1 - (currentSellFeePerThousand + 25)/1000);
        item["mintPrice"] = currentBuyPrice;
        item["sellPrice"] = currentSellPrice;
        item["moneyInContract"] = moneyInContract;
        item["currentSupply"] = newSupply;
        self.setState({
          liveNFTItem: item,
        });
        if (
          self.props.account == null ||
          data["to"].toLowerCase() !== self.props.account.address.toLowerCase()
        ) {
          return;
        }
        self.setState({
          transactionStatus: "Mint Complete",
        });
      })
      .on("error", function (event) {
        self.setState({
          transactionStatus: "Failed",
        });
      });
    bondingCurveV2Contract.events
      .ItemBurned()
      .on("data", async function (event) {
        let data = event.returnValues;
        console.log(data);
        if (data["authUUID"] !== item["authUUID"]) {
          return;
        }
        let pastBondingCurveMintEvents = await bondingCurveV2Contract.getPastEvents("ItemMinted", {
          fromBlock: 0,
          toBlock: 'latest'
        });
        let pastBondingCurveBurnEvents = await bondingCurveV2Contract.getPastEvents("ItemBurned", {
          fromBlock: 0,
          toBlock: 'latest'
        });
        let filteredPastBondingCurveMintEvents = pastBondingCurveMintEvents.filter(event => event.returnValues.authUUID === item.authUUID);
        let filteredPastBondingCurveBurnEvents = pastBondingCurveBurnEvents.filter(event => event.returnValues.authUUID === item.authUUID);
        let newSupply = filteredPastBondingCurveMintEvents.length - filteredPastBondingCurveBurnEvents.length;
        let tokenId = item["tokenId"];
        let currentBuyPrice = await encryptUtils.computeCurrentPrice(tokenId, newSupply + 1, "liquidv2");
        let currentSellPrice = await encryptUtils.computeCurrentPrice(tokenId, newSupply, "liquidv2");
        let moneyInContract = await encryptUtils.computeMoneyInContract(tokenId, "liquidv2");
        let currentBuyFeePerThousand = item["currentBuyFeePerThousand"];
        let currentSellFeePerThousand = item["currentSellFeePerThousand"];
        item["baseBuyPrice"] = currentBuyPrice;
        item["baseSellPrice"] = currentSellPrice;
        currentBuyPrice *= (1 + currentBuyFeePerThousand/1000);
        currentSellPrice *= (1 - (currentSellFeePerThousand + 25)/1000);
        item["mintPrice"] = currentBuyPrice;
        item["sellPrice"] = currentSellPrice;
        item["moneyInContract"] = moneyInContract;
        item["currentSupply"] = newSupply;
        self.setState({
          liveNFTItem: item,
        });
        if (
          self.props.account == null ||
          data["burner"].toLowerCase() !== self.props.account.address.toLowerCase()
        ) {
          return;
        }
        self.setState({
          transactionStatus: "Burn Complete",
        });
      })
      .on("error", function (event) {
        self.setState({
          transactionStatus: "Failed",
        });
      });
    loggingUtils.logEvent(
      this.props.account != null
        ? this.props.account.address
        : encryptUtils.getWalletUnconnectedUserId(),
      "streamer_profile",
      "streamer_profile_page_load",
      "info",
      "https://the402.xyz",
      {}
    );
  }

  async getStream() {
    // TODO add Livepeer AWS switching logic for create stream
    if(true) {
      let result = await fetch(
        "https://73vw7wmlk1.execute-api.us-west-2.amazonaws.com/dev/get_aws_stream_info",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            name: this.state.creatorAddress,
          }),
        }
      )
        .then((res) => res.json())
        .catch((err) => console.log(err));

      if (result != null && result.isActive) {
        this.setState({
          isActive: result.isActive,
          stream: result.stream,
        });
      }
    } else {
      let urlSplit = window.location.href.split("/");
      let tokenId = urlSplit[urlSplit.length - 1].split("?")[0];

      let result = await fetch(
        "https://73vw7wmlk1.execute-api.us-west-2.amazonaws.com/dev/getStreamFromName",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            name: tokenId,
          }),
        }
      )
        .then((res) => res.json())
        .catch((err) => console.log(err));

      if (result != null && result.exists && result.isActive) {
        this.setState({
          isActive: result.isActive,
          stream: result.stream,
        });
      }
    }
  }

  selectModal(modal) {
    this.setState({
      modalShown: modal,
    });
  }

  render() {
    // TODO move cam murdoch no show live nft server side
    let numSubscribers = 0;
    if(this.state.creatorAddress.toLowerCase() in this.state.subscriberStatuses) {
      numSubscribers = Object.keys(this.state.subscriberStatuses[this.state.creatorAddress.toLowerCase()]).length;
    }

    return (
      <div className="min-h-screen">
        <div>
          <PlatformSidebar
            modalShown={this.state.modalShown}
            selectModal={this.selectModal}
          />
          {
            this.state.modalShown === 'createAccount'
              ?
            <Onboarding selectModal={this.selectModal} />
              :
            this.state.modalShown === 'addFunds'
              ?
            <AddFunds selectModal={this.selectModal} />
              :
            this.state.modalShown === 'importFromPassword'
              ?
            <ImportFromPassword selectModal={this.selectModal} />
              :
            this.state.modalShown === "subscribe"
              ?
            <SubscribeModal
              selectModal={this.selectModal}
              account={this.props.account}
              item={{"creatorAddress": this.state.creatorAddress}}
              markAsSubscribed={this.markAsSubscribed}
            />
              :
            null
          }
        </div>
        {
          this.state.isActive &&
          this.state.stream != null &&
          this.state.shouldShowLiveStream &&
          (!window.location.href.includes("app.the402.xyz") || !this.state.shouldStreamInTestMode)
            ?
          <div className="flex flex-col">
            <div className="w-screen flex">
              <div className="mt-16">
                <LivestreamPage
                  account={this.props.account}
                  item={
                    this.state.liveNFTItem == null && this.state.createdItems.length > 0
                      ?
                    this.state.createdItems[0]
                      :
                    this.state.liveNFTItem
                  }
                  subscriberStatuses={this.state.subscriberStatuses}
                  selectSubscribeModal={this.selectSubscribeModal}
                  playbackId={this.state.stream.playbackId}
                  creatorAddress={this.state.creatorAddress}
                  creatorName={this.state.creatorName}
                  creatorImage={this.state.creatorImage}
                  emotes={this.state.emotes}
                  ens={this.state.ens}
                  setENS={this.setENS}
                  setAddresses={this.setAddresses}
                  addAddress={this.addAddress}
                  removeAddress={this.removeAddress}
                  addresses={this.state.addresses}
                  messages={this.state.messages}
                  addMessage={this.addMessage}
                  setAnimatedImageForUser={this.setAnimatedImageForUser}
                  setTransactionStatus={this.setTransactionStatus}
                  socials={this.state.socials}
                  currentMessage={this.state.currentMessage}
                  updateCurrentMessage={this.updateCurrentMessage}
                  nftSalesLivestream={this.state.nftSalesLivestream}
                  mintFromChat={this.mintFromChat}
                  payStreamer={this.payStreamer}
                  playbackURL={this.state.stream}
                  updateUserInfo={this.updateUserInfo}
                  userInfo={this.state.userInfo}
                  badgeInfo={this.state.badgeInfo}
                  userOwnedNFTs={this.state.userOwnedNFTs}
                  logMinuteAttended={this.logMinuteAttended}
                  triggerAnimation={this.triggerAnimation}
                  setMessageInfo={this.setMessageInfo}
                  nextToken={this.state.nextToken}
                  addPaginatedMessages={this.addPaginatedMessages}
                  addSubscribedMessage={this.addSubscribedMessage}
                />
                <div className="absolute dark:text-gray-200 font-bold text-gray-500 left-4 top-[70px]">
                  {this.state.addresses.length} Viewers
                </div>
              </div>
            </div>
            <ProfileInformationContainer
              account={this.props.account}
              createdItems={this.state.createdItems}
              livestreamURLs={this.state.livestreamURLs}
              livestreamURLPreviews={this.state.livestreamURLPreviews}
              selectItemForSubscribe={(_video) => this.selectSubscribeModal()}
              setTransactionStatus={this.setTransactionStatus}
              shouldShowLiveStreamForPastVods={this.state.shouldShowLiveStreamForPastVods}
              subscriberStatuses={this.state.subscriberStatuses}
            />
          </div>
            :
          <div className="flex flex-col-reverse sm:flex sm:w-screen sm:justify-center">
            <div className="flex flex-col">
              <ProfileBackground
                creatorAddress={this.state.creatorAddress}
                creatorBackgroundBlurredImage={this.state.creatorBackgroundBlurredImage}
                creatorImage={this.state.creatorImage}
                creatorName={this.state.creatorName}
                liveNFTItem={this.state.liveNFTItem}
              />
              <div className="flex">
                <div className="flex flex-col">
                  {
                    this.props.account != null &&
                    this.state.creatorAddress.toLowerCase() in this.state.subscriberStatuses &&
                    this.props.account.address.toLowerCase() in this.state.subscriberStatuses[this.state.creatorAddress.toLowerCase()]
                      ?
                    <div className="flex flex-row">
                      <div className="mt-2 sm:mt-16 ml-12 cursor-pointer elative hover:-translate-y-0 hover:scale-105 duration-500 ml-4 w-24 sm:w-28 h-8 flex justify-center items-center text-sm sm:text-sm text-gray-300 dark:text-gray-400 font-bold bg-zinc-600 dark:bg-zinc-800 rounded-lg">
                        Subscribed
                      </div>
                      <div className="mt-2 sm:mt-16 ml-4 text-black dark:text-white">
                        {numSubscribers}
                      </div>
                      <div className="mt-2 sm:mt-16 ml-2 text-gray-400 dark:text-gray-500">
                        Subscribers
                      </div>
                    </div>
                      :
                    <div className="flex flex-row">
                      <div className="mt-2 sm:mt-16 ml-12 cursor-pointer elative hover:-translate-y-0 hover:scale-105 duration-500 ml-4 w-20 sm:w-28 h-8 flex justify-center items-center text-sm sm:text-sm font-bold bg-blue-600 rounded-lg text-white" onClick={() => this.selectSubscribeModal()}>
                        Subscribe
                      </div>
                      <div className="mt-2 sm:mt-16 ml-4 text-black dark:text-white">
                        {numSubscribers}
                      </div>
                      <div className="mt-2 sm:mt-16 ml-2 text-gray-400 dark:text-gray-500">
                        Subscribers
                      </div>
                    </div>
                  }
                  {
                    this.props.account != null &&
                    this.state.creatorAddress.toLowerCase() === this.props.account.address.toLowerCase()
                      ?
                    <CreateLiveStreamButton
                      isForCreatorDashboard={false}
                      isForStreamerProfile={true}
                      streamName={this.state.creatorAddress.toLowerCase()}
                    />
                      :
                    null
                  }
                    <StreamerProfileSocials
                      socials={this.state.socials}
                    />
                </div>
                {
                  "global" in this.state.liveTimesByAuthUUID ||
                  (this.state.liveNFTItem != null && this.state.liveNFTItem.authUUID in this.state.liveTimesByAuthUUID)
                    ?
                  <div className="flex items-center ml-12 mt-4 sm:mt-16">
                    <div className="animated-box-streamer-profile in mt-4 mr-4">
                      <div className="text-zinc-500 dark:text-zinc-400 text-sm">
                        Live
                      </div>
                      <div className="text-black font-semibold dark:text-white">
                        {
                          "global" in this.state.liveTimesByAuthUUID
                            ?
                          this.state.liveTimesByAuthUUID["global"]
                            :
                          this.state.liveTimesByAuthUUID[this.state.liveNFTItem.authUUID]
                        }
                      </div>
                    </div>
                    {
                      this.doesHaveCalendarEventTimes()
                        ?
                      <AddToCalendar
                        event={{
                          title: this.state.creatorName + " live",
                          description: this.state.creatorName + " going live on the402",
                          location: window.location.href,
                          startTime: this.getCalendarStartTime(),
                          endTime: this.getCalendarEndTime()
                        }}
                        buttonTemplate={{ 'calendar-plus-o': 'left' }}
                      />
                        :
                      null
                    }
                  </div>
                    :
                  null
                }
              </div>
              {
                this.state.liveNFTItem != null && this.state.creatorAddress !== "0x13ef06797f095d5c62babf704d983cf1b4bde9e5"
                  ?
                <div className="w-screen flex mt-8 justify-center items-center">
                  <LiveMintDetails
                    account={this.props.account}
                    item={this.state.liveNFTItem}
                    liveNFTDaysLeft={this.state.liveNFTDaysLeft}
                    liveNFTHoursLeft={this.state.liveNFTHoursLeft}
                    liveNFTMinutesLeft={this.state.liveNFTMinutesLeft}
                    liveNFTSecondsLeft={this.state.liveNFTSecondsLeft}
                    liveNFTName={this.state.liveNFTName}
                    liveNFTBuyPrice={this.state.liveNFTBuyPrice}
                    liveNFTBuyCreatorFee={this.state.liveNFTBuyCreatorFee}
                    liveNFTBuyPriceTotal={this.state.liveNFTBuyPriceTotal}
                    liveNFTSellPrice={this.state.liveNFTSellPrice}
                    liveNFTSellCreatorFee={this.state.liveNFTSellCreatorFee}
                    liveNFTSellPriceTotal={this.state.liveNFTSellPriceTotal}
                    setTransactionStatus={this.setTransactionStatus}
                  />
                </div>
                  :
                null
              }
              <ProfileInformationContainer
                account={this.props.account}
                createdItems={this.state.createdItems}
                livestreamURLs={this.state.livestreamURLs}
                livestreamURLPreviews={this.state.livestreamURLPreviews}
                selectItemForSubscribe={(_video) => this.selectSubscribeModal()}
                setTransactionStatus={this.setTransactionStatus}
                shouldShowLiveStreamForPastVods={this.state.shouldShowLiveStreamForPastVods}
                subscriberStatuses={this.state.subscriberStatuses}
              />
            </div>
          </div>
        }
        <TransactionStatus
          transactionStatus={this.state.transactionStatus}
          item={this.state.liveNFTItem}
        />
      </div>
    );
  }
}

export default StreamerProfile;
